import { RetentionOfferFragment } from '@portal/schema';

export const savings = (offer: RetentionOfferFragment, amount: number): number => {
  const { discountPercent, discountAmount } = offer.detail.action;

  if (discountPercent) return amount - amount * (discountPercent / 100);
  if (discountAmount) return amount - Math.min(...[amount, discountAmount]);
  return amount;
};
